import { Drug } from '../../application/types/drug.ts';

export const getDrugDisplayName = (drug: Drug) => {
    if (drug === null) {
        return '';
    }

    return `${drug?.drugName ?? ''} ${drug?.concentration ?? ''}${drug?.concentrationUnit ?? ''}, ${drug?.quantity ?? ''}${drug?.quantityUnit ?? ''}`;
};
export const getDrugDisplayNameBrackets = (drug: Drug) => {
    return `${drug?.drugName ?? ''} ${drug?.drugName ? `(${drug?.concentration ?? ''} ${drug?.concentrationUnit ?? ''}, ${drug?.quantity ?? ''}ml)` : ''}`;
};
